import { Controller } from 'stimulus';

export default class AsyncValidationErrorsController extends Controller {
  handleValidationError(e) {
    this.removeLoadingIndicator();

    const [response] = e.detail;
    const userErrors = response?.errors?.user
      ? response.errors.user
      : response?.errors
        ? {}
        : response;
    const formElements = Array.from(
      e.target.querySelectorAll('input, textarea, select'),
    );

    this.clearPreviousErrors(formElements);

    Object.entries(userErrors).forEach(([field, messages]) => {
      if (field === 'detached') {
        const element = document.querySelector('.detached-async-errors-target');

        for (let error of messages) {
          if (element) this.showErrorMessage(error, element, true);
        }
      } else {
        const element = formElements.find(
          (el) =>
            !el.disabled &&
            el.name.includes(field) &&
            (el.name.includes('[') || el.name.includes(']')),
        );
        if (element) this.showErrorMessage(messages[0], element);
      }
    });
  }

  showErrorMessage(msg, element, isDetached = false) {
    const errorElement = element.ownerDocument.createElement('div');
    errorElement.classList.add('validation-error');
    errorElement.textContent = msg;

    if (isDetached) errorElement.classList.add('validation-error--detached');
    element.after(errorElement);

    const errorElementHeight = `${errorElement.offsetHeight}px`;
    errorElement.style.maxHeight = '0';

    requestAnimationFrame(() => {
      errorElement.style.maxHeight = errorElementHeight;
      errorElement.style.opacity = '1';
    });
  }

  clearPreviousErrors(formElements) {
    const detachedErrors = document.querySelectorAll(
      '.validation-error--detached',
    );
    if (detachedErrors) {
      detachedErrors.forEach((el) => {
        el.remove();
      });
    }

    formElements.forEach((el) => {
      if (el.nextElementSibling?.classList.contains('validation-error'))
        el.nextElementSibling?.remove();
    });
  }

  removeLoadingIndicator() {
    document
      .querySelector('.contents-loading')
      ?.classList.remove('contents-loading');
  }
}
